import type { RouteRecordRaw } from 'vue-router'

import { organizationDetailLayoutMeta } from './shared'

const routePartnerDetail: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/views/relations/OrganizationDetailView.vue')
  },
  name: 'partner-detail',
  path: '',
}

const routePartnerFileOverview: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/submenus/file/SubmenuFiles.vue')
  },
  name: 'partner-file-overview',
  path: 'file-overview',
}

const routePartnerRoot: RouteRecordRaw = {
  children: [routePartnerDetail, routePartnerFileOverview],
  component: async () => {
    return await import('@/components/relationships/organizations/OrganizationDetailBase.vue')
  },
  meta: organizationDetailLayoutMeta,
  path: 'partners/:id',
}

export { routePartnerDetail, routePartnerFileOverview, routePartnerRoot }
